/* eslint-disable max-len */
import { template_translation } from '../lang/TemplateTranslation';
const t = template_translation;

/** 10. ライトの灯った部屋*/
export const template10 = {
  title: t.to('ライトの灯った部屋', 'title10'),
  desc: t.to(
    '奥行き３０、幅３０、高さ１０の部屋にポイントライトを一つ備えました。この壁はすり抜けることができません。すり抜けられない壁を作るには、壁に静止した物体属性をつけて、カメラをシーンに追加します。',
    'desc10'
  ),
  img: '../public/template/10.png',
  xml: `<xml xmlns="http://www.w3.org/1999/xhtml">
  <variables>
  </variables>
  <block type="a-scene-start" x="150" y="90">
    <field name="is_init">off</field>
    <field name="hasController">on</field>
    <statement name="IN">
      <block type="logic_function_call_v">
        <field name="FUNCTION_NAME">room</field>
        <field name="arg">depth = 30, width = 30, height = 10</field>
        <next>
          <block type="a-light_v2">
            <field name="typeAtt">point</field>
            <field name="intensity">1</field>
            <field name="position-x">0</field>
            <field name="position-y">8</field>
            <field name="position-z">0</field>
            <next>
              <block type="a-camera_v2.1">
                <field name="position-x">0</field>
                <field name="position-y">1.7</field>
                <field name="position-z">0</field>
                <field name="avator_type">teat_Avatar_ver2.glb</field>
                <field name="click_type">cursor</field>
              </block>
            </next>
          </block>
        </next>
      </block>
    </statement>
  </block>
  <block type="logic_function_v2" x="150" y="430">
    <field name="FUNCTION_NAME">room</field>
    <field name="arg">depth, width, height</field>
    <statement name="IN">
      <block type="cube_v2">
        <field name="id">up</field>
        <field name="position-x">0</field>
        <field name="position-y">= height</field>
        <field name="position-z">0</field>
        <value name="COLOUR">
          <shadow type="color_value_v2">
            <field name="COLOUR">#05f24c</field>
          </shadow>
        </value>
        <value name="ATTR">
          <block type="scale_v2">
            <field name="scale-x">= width </field>
            <field name="scale-y">1</field>
            <field name="scale-z">= depth</field>
            <value name="ATTR">
              <block type="a-static-body_v2">
              </block>
            </value>
          </block>
        </value>
        <next>
          <block type="cube_v2">
            <field name="id">ground</field>
            <field name="position-x">0</field>
            <field name="position-y">0</field>
            <field name="position-z">0</field>
            <value name="COLOUR">
              <shadow type="color_value_v2">
                <field name="COLOUR">#05f2bd</field>
              </shadow>
            </value>
            <value name="ATTR">
              <block type="scale_v2">
                <field name="scale-x">= width </field>
                <field name="scale-y">1</field>
                <field name="scale-z">= depth</field>
                <value name="ATTR">
                  <block type="a-static-body_v2">
                  </block>
                </value>
              </block>
            </value>
            <next>
              <block type="cube_v2">
                <field name="id">front_wall</field>
                <field name="position-x">0</field>
                <field name="position-y">= height/2</field>
                <field name="position-z">= -depth / 2</field>
                <value name="COLOUR">
                  <shadow type="color_value_v2">
                    <field name="COLOUR">#d78f15</field>
                  </shadow>
                </value>
                <value name="ATTR">
                  <block type="scale_v2">
                    <field name="scale-x">= width </field>
                    <field name="scale-y">= height</field>
                    <field name="scale-z">1</field>
                    <value name="ATTR">
                      <block type="a-static-body_v2">
                      </block>
                    </value>
                  </block>
                </value>
                <next>
                  <block type="cube_v2">
                    <field name="id">right_wall</field>
                    <field name="position-x">= width / 2</field>
                    <field name="position-y">= height / 2</field>
                    <field name="position-z">0</field>
                    <value name="COLOUR">
                      <shadow type="color_value_v2">
                        <field name="COLOUR">#d78f15</field>
                      </shadow>
                    </value>
                    <value name="ATTR">
                      <block type="scale_v2">
                        <field name="scale-x">1</field>
                        <field name="scale-y">= height</field>
                        <field name="scale-z">= depth</field>
                        <value name="ATTR">
                          <block type="a-static-body_v2">
                          </block>
                        </value>
                      </block>
                    </value>
                    <next>
                      <block type="cube_v2">
                        <field name="id">left_wall</field>
                        <field name="position-x">= -width / 2</field>
                        <field name="position-y">= height / 2</field>
                        <field name="position-z">0</field>
                        <value name="COLOUR">
                          <shadow type="color_value_v2">
                            <field name="COLOUR">#d78f15</field>
                          </shadow>
                        </value>
                        <value name="ATTR">
                          <block type="scale_v2">
                            <field name="scale-x">1</field>
                            <field name="scale-y">= height</field>
                            <field name="scale-z">= depth</field>
                            <value name="ATTR">
                              <block type="a-static-body_v2">
                              </block>
                            </value>
                          </block>
                        </value>
                        <next>
                          <block type="cube_v2">
                            <field name="id">back_wall</field>
                            <field name="position-x">0</field>
                            <field name="position-y">= height / 2</field>
                            <field name="position-z">= depth / 2</field>
                            <value name="COLOUR">
                              <shadow type="color_value_v2">
                                <field name="COLOUR">#d78f15</field>
                              </shadow>
                            </value>
                            <value name="ATTR">
                              <block type="scale_v2">
                                <field name="scale-x">= width </field>
                                <field name="scale-y">= height</field>
                                <field name="scale-z">1</field>
                                <value name="ATTR">
                                  <block type="a-static-body_v2">
                                  </block>
                                </value>
                              </block>
                            </value>
                          </block>
                        </next>
                      </block>
                    </next>
                  </block>
                </next>
              </block>
            </next>
          </block>
        </next>
      </block>
    </statement>
  </block>
</xml>

`,
};
